/**
 * @generated SignedSource<<581a06b0a2b329b2f330d6f04b2d6585>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultBuyingCreditsOperation = "FAILED" | "SUCCESS" | "SUCCESS_FOR_TRIAL" | "WAITING_FOR_APPROVAL";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type ServiceRechargeCreditsInput = {
  autoRefill: boolean;
  credits: number;
  currencyCode: string;
  expirationDate?: string | null;
  isForTrial?: boolean | null;
  isForTrialOnFirstPackage?: boolean | null;
  returnUrlFromApproval?: string | null;
  service: ServicesWithCredits;
  shopifyChargeID?: string | null;
};
export type useDiscoveryAiCreditsBuyMutation$variables = {
  input: ServiceRechargeCreditsInput;
};
export type useDiscoveryAiCreditsBuyMutation$data = {
  readonly buyServiceCredits: {
    readonly errorMessage: string | null;
    readonly result: ResultBuyingCreditsOperation;
  } | null;
};
export type useDiscoveryAiCreditsBuyMutation = {
  response: useDiscoveryAiCreditsBuyMutation$data;
  variables: useDiscoveryAiCreditsBuyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceBuyingResultOperation",
    "kind": "LinkedField",
    "name": "buyServiceCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDiscoveryAiCreditsBuyMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDiscoveryAiCreditsBuyMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "799c51bce0c3768c36d707ab6d49307f",
    "id": null,
    "metadata": {},
    "name": "useDiscoveryAiCreditsBuyMutation",
    "operationKind": "mutation",
    "text": "mutation useDiscoveryAiCreditsBuyMutation(\n  $input: ServiceRechargeCreditsInput!\n) {\n  buyServiceCredits(input: $input) {\n    result\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "e68064fc5753707c9fe82db2c1e4ccde";

export default node;
